// Copyright 2025, Imprivata, Inc.  All rights reserved.

import React from 'react';

import FaceBioImg from '../../assets/icons/authenticators/face_bio.svg?react';
import IdImg from '../../assets/icons/authenticators/imprivata_ID.svg?react';
import PasswordImg from '../../assets/icons/authenticators/password.svg?react';
import PinImg from '../../assets/icons/authenticators/pin.svg?react';
import ProxCardImg from '../../assets/icons/authenticators/prox_card.svg?react';
import TempCodeImg from '../../assets/icons/authenticators/temp_code.svg?react';
import UsernameImg from '../../assets/icons/authenticators/username.svg?react';

export enum AuthenticatorFactorType {
  FACE = 'face',
  PROX_CARD = 'prox-card',
  PASSWORD = 'password',
  PIN = 'pin',
  USERNAME = 'username',
  TEMP_CODE = 'temp-code',
  IMPRIVATA_ID = 'imprivata-id',
}

const mapFactorTypeToNameAndIcon = (factorType: string) => {
  switch (factorType) {
    case AuthenticatorFactorType.FACE:
      return { name: 'Face recognition', icon: <FaceBioImg /> };
    case AuthenticatorFactorType.PROX_CARD:
      return { name: 'Proximity Card', icon: <ProxCardImg /> };
    case AuthenticatorFactorType.PASSWORD:
      return { name: 'Password', icon: <PasswordImg /> };
    case AuthenticatorFactorType.PIN:
      return { name: 'PIN', icon: <PinImg /> };
    case AuthenticatorFactorType.USERNAME:
      return { name: 'Username', icon: <UsernameImg /> };
    case AuthenticatorFactorType.TEMP_CODE:
      return { name: 'Temporary Code', icon: <TempCodeImg /> };
    case AuthenticatorFactorType.IMPRIVATA_ID:
      return { name: 'Imprivata ID', icon: <IdImg /> };
    default:
      return { name: factorType, icon: <UsernameImg /> };
  }
};

export default mapFactorTypeToNameAndIcon;
